<template>
  <div id="OverlayOrchestrator">
    <NotificationStack />
    <OverlayQueue />
  </div>
</template>

<script setup>
import NotificationStack from '@/presentation/components/overlay/NotificationStack.vue';
import OverlayQueue from '@/presentation/components/overlay/OverlayQueue.vue';
</script>

<style lang="scss" scoped></style>
